import { RequestStatusBadge } from "@/components/common/section-components/badge/RequestStatusBadge";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";

interface Props {
  detail: any;
}

export const DetailInfoCard = ({ detail }: Props) => {



  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>

          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Titular cuenta:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">{detail?.razonSocial}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="10px">
              <Text className="account-title-label">CUIT/CUIL Cuenta:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="10px">
              <Text className="account-value-label">{detail?.cuitCuil ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Tipo de sociedad:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {detail?.tipoSociedad ?? "-"}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="10px">
              <Text className="account-title-label">Mail verificado:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="10px">
              <Text className="account-value-label">
                {detail?.email ?? "-"}
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>

      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>

          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Usuario Mobile:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {detail?.datosUsuario?.nombreApellido ?? "-"}
              </Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="10px">
              <Text className="account-title-label">DNI Usuario:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="10px">
              <Text className="account-value-label">
                {detail?.datosUsuario?.dni ?? "-"}
              </Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="10px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <RequestStatusBadge status={detail?.estado} noPaddingY />
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
